import PlatformAPIEventType from "./PlatformAPIEventType";

export default class BaseTrackingController {
    /**
     * 
     * @param {soma.EventDispatcher} dispatcher 
     */
    constructor(dispatcher) {
        this._dispatcher = dispatcher;
    }

    _dispatchInteractionEvent(eventName, eventParams, elapsedTime) {
        const payload = {
            eventName: eventName,
            eventParams: eventParams,
            elapsedTime: Math.round(elapsedTime)
        }
        this._dispatcher.dispatch(PlatformAPIEventType.INTERACTION, payload);
    }

    _dispatchProgressEvent(value, elapsedTime) {
        this._dispatcher.dispatch(PlatformAPIEventType.PROGRESS, {
            progressValue: value,
            elapsedTime: Math.round(elapsedTime)
        });
    }
}
